import React, { useState } from 'react';
import '../styles/ChatWithAI.css';
import { baseUrl } from '../config';



function ChatWithAI({ isOpen, onClose }) {
  const [inputText, setInputText] = useState('');
  const [messages, setMessages] = useState([]);

  const handleSendMessage = () => {
    if (inputText.trim()) {
      setMessages([...messages, { user: 'User', text: inputText }]);
      setInputText('');
      // Call your AI backend here to send `inputText` and get a response, then update messages
      setTimeout(() => {
        // Mock response from AI
        const aiResponse = "AI's response to: " + inputText;
        setMessages((prevMessages) => [...prevMessages, { user: 'AI', text: aiResponse }]);
      }, 1000);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="chat-container">
      <div className="chat-header">
        <h4>Chat with AI</h4>
        <button onClick={onClose} className="close-chat-btn">X</button>
      </div>
      <div className="chat-messages">
        {messages.map((message, index) => (
          <div key={index} className={`chat-message ${message.user === 'User' ? 'user-message' : 'ai-message'}`}>
            <strong>{message.user}:</strong> {message.text}
          </div>
        ))}
      </div>
      <div className="chat-input-container">
        <input
          type="text"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder="Type your message..."
          className="chat-input"
        />
        <button onClick={handleSendMessage} className="send-btn">Send</button>
      </div>
    </div>
  );
}

export default ChatWithAI;

